<template>
  <div>
    <Loading :value="loading"></Loading>
    <!-- MODAL AJOUTER UNE ZONES -->
    <v-dialog
      v-model="dialogDetailCmd"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Detail de la commande analyser par le comparateur </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row class="mb-4">
            <v-flex xs12 class="mr-3">
              <v-card>
                <v-toolbar class="text-xs-center" color="grey" dark>
                  <v-toolbar-title>Commande initiale </v-toolbar-title>
                </v-toolbar>
                <v-card-title class="text-xs-center">
                  <v-layout class="mb-4">
                    <v-flex xs6>
                      <v-chip
                        label
                        outline
                        color="green darken-1"
                        class="elevation-4"
                        style="width:90%"
                      >
                        <span class="subheading"
                          >Montant total de la commande:
                        </span>
                        <span class="title">
                          {{ cmdInit.mntTotalFormat }} Fcfa
                        </span>
                      </v-chip>
                      <v-chip
                        label
                        outline
                        color="green darken-1"
                        class="elevation-4"
                        style="width:90%"
                      >
                        <span class="subheading"
                          >Référence de la commande:
                        </span>
                        <span class="title"> {{ cmdInit.refCmd }}</span>
                      </v-chip>
                      <v-chip
                        label
                        outline
                        color="green darken-1"
                        class="elevation-4"
                        style="width:90%"
                      >
                        <span class="subheading"
                          >Initiateur de la commande:
                        </span>
                        <span class="title"> {{ cmdInit.userCreate }}</span>
                      </v-chip>
                      <v-chip
                        label
                        outline
                        color="green darken-1"
                        class="elevation-4"
                        style="width:90%"
                      >
                        <span class="subheading">Date: </span>
                        <span class="title"> {{ cmdInit.dateCom }}</span>
                      </v-chip>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs12>
                      <data-tables :data="cmdInit.optionCmd">
                        <el-table-column prop="libelleProd" label="Libelle">
                        </el-table-column>
                        <el-table-column prop="qteProd" label="Quantite">
                        </el-table-column>
                        <el-table-column
                          prop="prixU"
                          label="Prix Unitaire(Fcfa)"
                        >
                          <template slot-scope="scope">
                            <el-tag>
                              {{
                                new Intl.NumberFormat().format(scope.row.prixU)
                              }}</el-tag
                            >
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="tva"
                          label="Tva %"
                        ></el-table-column>
                        <el-table-column prop="mntTotal" label="Total (Fcfa)">
                          <template slot-scope="scope">
                            <el-tag> {{ scope.row.mntTotalFormat }}</el-tag>
                          </template>
                        </el-table-column>
                      </data-tables>
                    </v-flex>
                  </v-layout>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout row class="mb-4">
            <v-flex xs12 class="mb-3">
              <v-card>
                <v-toolbar class="text-xs-center" color="cyan" dark>
                  <v-toolbar-title
                    >Commande(s) suggérée(s) par le comparateur
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-title class="text-xs-center">
                  <v-layout wrap class="mb-3">
                    <v-flex xs8>
                      <v-chip
                        label
                        outline
                        color="orange darken-1"
                        class="elevation-4"
                        style="width:90%"
                      >
                        <span class="subheading"
                          >Montant total economisé:
                        </span>
                        <span class="title">
                          {{ cmdInit.beneficeTotalFormat }} Fcfa
                        </span>
                      </v-chip>
                    </v-flex>
                    <v-flex xs4>
                      <v-chip
                        color="orange"
                        text-color="white"
                        style="font-size:18px"
                      >
                        <v-avatar class="orange darken-4">
                          {{ nbCmdDerive }}
                        </v-avatar>
                        Commande(s)
                      </v-chip>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex
                      class="mb-4 pl-3 pt-3 mr-3 elevation-5"
                      xs12
                      v-for="cmd in cmdDerivees"
                      :key="cmd.idCmd"
                    >
                      <v-flex xs6 class="mb-2">
                        <v-chip
                          label
                          outline
                          color="green darken-1"
                          class="elevation-4"
                          style="width:90%"
                        >
                          <span class="subheading"
                            >Reference de la commande:
                          </span>
                          <span class="title"> {{ cmd.refCmd }}</span>
                        </v-chip>
                        <v-chip
                          label
                          outline
                          color="green darken-1"
                          class="elevation-4"
                          style="width:90%"
                        >
                          <span class="subheading"
                            >Montant total de la commande:
                          </span>
                          <span class="title">
                            {{ cmd.mntTotalFormat }} Fcfa
                          </span>
                        </v-chip>
                        <v-chip
                          label
                          outline
                          color="green darken-1"
                          class="elevation-4"
                          style="width:90%"
                        >
                          <span class="subheading">Date: </span>
                          <span class="title"> {{ cmd.dateCom }} </span>
                        </v-chip>
                        <v-chip
                          label
                          outline
                          color="green darken-1"
                          class="elevation-4"
                          style="width:90%"
                        >
                          <span class="subheading"
                            >Initiateur de la commande:
                          </span>
                          <span class="title"> {{ cmd.userCreate }}</span>
                        </v-chip>
                      </v-flex>
                      <v-flex xs12>
                        <data-tables :data="cmd.optionCmd">
                          <el-table-column prop="libelleProd" label="Libelle">
                          </el-table-column>
                          <el-table-column prop="qteProd" label="Quantite">
                          </el-table-column>
                          <el-table-column prop="prixU" label="Prix Unitaire">
                            <template slot-scope="scope">
                              <el-tag>
                                {{
                                  new Intl.NumberFormat().format(
                                    scope.row.prixU
                                  )
                                }}</el-tag
                              >
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="tva"
                            label="Tva"
                          ></el-table-column>
                          <el-table-column prop="mntTotal" label="Total (Fcfa)">
                            <template slot-scope="scope">
                              <el-tag> {{ scope.row.mntTotalFormat }}</el-tag>
                            </template>
                          </el-table-column>
                        </data-tables>
                        <v-divider class="mb-3"></v-divider>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "",
  props: ["show", "cmdDerivees", "cmdInit"],
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,
      dialogDetailCmd: false,
      nbCmdDerive: 0
    };
  },

  computed: {},
  watch: {
    show: function(newValue, oldvalue) {
      this.dialogDetailCmd = newValue;
      if (newValue == true) {
        this.nbCmdDerive = this.cmdDerivees.length;
      }
    }
  },

  methods: {
    closeDialog() {
      this.$emit("close");
    }
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/comparateur/ModalDetailCommande.vue